"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ProductRatingsRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function ProductRatingsRenderHandler(validateSkuResponse) {
    var _this;
    (0, _classCallCheck2["default"])(this, ProductRatingsRenderHandler);
    _this = _callSuper(this, ProductRatingsRenderHandler);
    _this.pre.push(function () {
      _this.enabled = validateSkuResponse.isRatingsSkuEnabled;
      _this.asin = validateSkuResponse.asin;
      _this.roaInstanceId = validateSkuResponse.roaInstanceId;
      _this.customization = validateSkuResponse.ratingsCustomization;
      _this.linkSelector = _this.getLinkSelector(_this.customization);
      _this.rfaRatingsContainerId = _this.getContainerId(_this.customization);
      _this.tag = 'amazon-product-rating';
    });
    return _this;
  }
  (0, _inherits2["default"])(ProductRatingsRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(ProductRatingsRenderHandler, [{
    key: "isShortHandRatingFeatureEnabled",
    value: function isShortHandRatingFeatureEnabled(customization) {
      return (customization === null || customization === void 0 ? void 0 : customization.showShortHandRating) === true;
    }
  }, {
    key: "getLinkSelector",
    value: function getLinkSelector(customization) {
      var _window$ratings, _window$ratings2;
      return this.isShortHandRatingFeatureEnabled(customization) ? ((_window$ratings = window.ratings) === null || _window$ratings === void 0 || (_window$ratings = _window$ratings.shortHandRating) === null || _window$ratings === void 0 ? void 0 : _window$ratings.linkSelector) || "" : ((_window$ratings2 = window.ratings) === null || _window$ratings2 === void 0 ? void 0 : _window$ratings2.linkSelector) || "";
    }
  }, {
    key: "getContainerId",
    value: function getContainerId(customization) {
      return this.isShortHandRatingFeatureEnabled(customization) ? _constants.BWA_WIDGET_CONTAINER_IDS.BWA_RFA_SHORT_HAND_RATING_CONTAINER_ID : _constants.BWA_WIDGET_CONTAINER_IDS.BWA_RFA_RATING_CONTAINER_ID;
    }
  }, {
    key: "getShortHandRatingCssClass",
    value: function getShortHandRatingCssClass() {
      return 'bwa-short-hand-rating-position';
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.render();
            case 2:
              this.setupEventListeners();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "validateAndRerender",
    value: function () {
      var _validateAndRerender = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(validateSkuResponseAfterVariantChange) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.enabled = validateSkuResponseAfterVariantChange.isRatingsSkuEnabled;
              this.asin = validateSkuResponseAfterVariantChange.asin;
              this.roaInstanceId = validateSkuResponseAfterVariantChange.roaInstanceId;
              this.customization = validateSkuResponseAfterVariantChange.ratingsCustomization;
              this.linkSelector = this.getLinkSelector(this.customization);
              this.rfaRatingsContainerId = this.getContainerId(this.customization);
              this.clearProductRatingsTag();
              this.render();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function validateAndRerender(_x) {
        return _validateAndRerender.apply(this, arguments);
      }
      return validateAndRerender;
    }()
  }, {
    key: "clearProductRatingsTag",
    value: function () {
      var _clearProductRatingsTag = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var productRatingsTags;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              productRatingsTags = (0, _utils.safeGetElementsByTagName)(this.tag);
              while (productRatingsTags.length > 0) {
                productRatingsTags[0].remove();
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function clearProductRatingsTag() {
        return _clearProductRatingsTag.apply(this, arguments);
      }
      return clearProductRatingsTag;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.enabled) {
                this.injectProductRatingsTag();
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "createRatingTag",
    value: function createRatingTag() {
      var ratingsTag = document.createElement(this.tag);
      ratingsTag.setAttribute('product-id', this.asin);
      if (this.customization) {
        var _this$customization$i, _this$customization$i2, _this$customization$i3, _this$customization$s;
        ratingsTag.setAttribute('star-size', this.customization.starSize);
        ratingsTag.setAttribute('font-family', this.customization.fontFamily);
        ratingsTag.setAttribute('color-mode', this.customization.colorMode);
        ratingsTag.setAttribute('show-social-proofing', (_this$customization$i = this.customization.isSocialProofingEnabled) !== null && _this$customization$i !== void 0 ? _this$customization$i : 'false');
        ratingsTag.setAttribute('show-rating-number', (_this$customization$i2 = this.customization.isRatingNumberEnabled) !== null && _this$customization$i2 !== void 0 ? _this$customization$i2 : 'false');
        ratingsTag.setAttribute('expandable-rating', (_this$customization$i3 = this.customization.isExpandableRatingEnabled) !== null && _this$customization$i3 !== void 0 ? _this$customization$i3 : 'false');
        ratingsTag.setAttribute('show-short-hand-rating', (_this$customization$s = this.customization.showShortHandRating) !== null && _this$customization$s !== void 0 ? _this$customization$s : 'false');
      }
      return ratingsTag;
    }
  }, {
    key: "injectProductRatingsTag",
    value: function injectProductRatingsTag() {
      var ratingsTag = this.createRatingTag();
      if (this.isShortHandRatingFeatureEnabled(this.customization)) {
        this.insertShortHandRatingContainer();
      } else {
        // The container is added in the BwAShopifyThemeApp to leverage Shopify drag and drop feature
        // (https://go.aka.amazon.com/amazon-product-rating-container)
      }
      (0, _utils.insertElementWithFallback)(this.rfaRatingsContainerId, ratingsTag, this.linkSelector);
    }
  }, {
    key: "insertShortHandRatingContainer",
    value: function insertShortHandRatingContainer() {
      var shortHandRatingDiv = document.createElement('div');
      shortHandRatingDiv.id = this.rfaRatingsContainerId;
      shortHandRatingDiv.style.cssText = 'position: absolute; display: flex; z-index: 10;';
      shortHandRatingDiv.classList.add(this.getShortHandRatingCssClass());
      if (!(0, _utils.safeGetElementById)(this.rfaRatingsContainerId)) {
        (0, _utils.insertElementAsLastChild)(this.linkSelector, shortHandRatingDiv);
      }
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.VARIANT_UPDATED, /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(event) {
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this2.validateAndRerender(event.detail.validateSkuResponse);
              case 2:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=product-ratings-render-handler.js.map
